<p-toast position="top-right" key="save"></p-toast>
<div class="fixed transform z-5" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>
<div class="bg-default px-3 pb-3" id="htmldata" #htmldata>
    <div class="flex justify-content-between align-items-center title-bg title-case" style="margin-bottom: 5px;">
      <div class="conten">
        <div class="btn"><a>Stroke Quality Metrics</a></div>
      </div>
    </div>
<div class="grid justify-content-end">
    <div class="col-12 md:col-6 lg:col-2">
      <label for="FirstName"
        [ngStyle]="filterTypeErrorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}"><b>Filter
          Type</b></label>
      <p-dropdown [options]="selectedFacilityOptions" [(ngModel)]="selectedFilterType" placeholder="Select Filter Type"
        (onChange)="onChangeFilterType($event)" optionLabel="name" optionValue="value" class="mr-2"></p-dropdown>
    </div>
    <div *ngIf="filterTypeBool" class="col-12 md:col-6 lg:col-2">
      <label *ngIf="facilityQPSLbl == 1"><b
          [ngStyle]="facilityErrorBool && facilityQPSLbl == 1 ? {'color':'red','font-size':'15px'} : {'color':'black'}">Facility</b></label>
      <label *ngIf="facilityQPSLbl == 2"><b
          [ngStyle]="facilityErrorBool && facilityQPSLbl == 2 ? {'color':'red','font-size':'15px'} : {'color':'black'}">System</b></label>
      <label *ngIf="facilityQPSLbl == 3"><b
          [ngStyle]="facilityErrorBool && facilityQPSLbl == 3 ? {'color':'red','font-size':'15px'} : {'color':'black'}">Regional</b></label>
      <p-dropdown #dd [options]="SelectListFilter" [(ngModel)]="selectFacilityPIOptions"
        optionLabel="Text" [filter]="true" filterBy="Text" placeholder="-- Select --"
        optionValue="Value" class="mr-2"></p-dropdown>
    </div>
     <!-- Newly Added Spoke Side -->
     <div class="col-12 md:col-6 lg:col-2" *ngIf="spokeSiteBool == true">
      <label for="FirstName"><b>Spoke Site</b></label>
      <p-dropdown [options]="spokeSiteOpions" [(ngModel)]="spokeSite" optionLabel="Text" optionValue="Value"
        class="mr-2"></p-dropdown>
    </div>
    <div class="col-12 md:col-6 lg:col-2">
        <label for="FirstName"><b>Time Frame:</b></label>
        <span class="p-input-icon-right w-full mt-1" id="frame_up">
          <p-dropdown [options]="timeFameList" (onChange)="onChangeTimeFrame($event)" [(ngModel)]="timeFrame"
            class="form-control" optionLabel="name" optionValue="value">
          </p-dropdown>
        </span>
      </div>
      <div class="col-12 md:col-6 lg:col-2" *ngIf="showDateBool == true">
        <label for="FirstName"><b
            [ngStyle]="specificDatecolorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">Date:</b></label>
        <p-calendar [(ngModel)]="txtSpecificDate" [minDate]="minDate" [showIcon]="true" inputId="icon" class="mr-2">
        </p-calendar>
      </div>
      <div class="col-12 md:col-6 lg:col-2" *ngIf="showStartEndDateBool == true">
        <label for="FirstName"><b
            [ngStyle]="textStrtColorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">Start
            Date:</b></label>
        <p-calendar [(ngModel)]="txtStartDate" [minDate]="minDate" [showIcon]="true" inputId="icon" class="mr-2">
        </p-calendar>
      </div>
      <div class="col-12 md:col-6 lg:col-2" *ngIf="showStartEndDateBool == true">
        <label for="FirstName"><b
            [ngStyle]="textEndColorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">End
            Date:</b></label>
        <p-calendar [(ngModel)]="txtEndDate" [showIcon]="true" inputId="icon" class="mr-2">
        </p-calendar>
      </div>
  </div>
  <div class="md:col-12 px-0">
    <!-- Search Filters SelectEnd -->
    <div class="flex justify-content-end mb-2" id="search_chart_excel_btn">
        <p-button *ngIf="dataForExcelBool" label="Export to Excel" icon="pi pi-upload" (click)="exportExcel()" [loading]="exportExcelLoader"
        class="p-button-primary mr-2 export-largescreen"></p-button>
      <!-- Search and Export button start -->
      <p-button label="Search" icon="pi pi-search" (click)="GetStrokeQualityMetricsData('click')"
        [loading]="SearchLoader == true" class="p-button-primary"></p-button>
    </div><!-- Search and Export button end -->
  </div>

  <div class="casesGrid mt-2">
    <p-table #dt [value]="strokeQualityMetricsData" [rows]="rows" styleClass="p-datatable-striped p-datatable-gridlines"
      [paginator]="true" sortMode="multiple" [lazy]="true" (onLazyLoad)="lazyLoadSchedules($event)"
      responsiveLayout="scroll" [rowHover]="true" dataKey="Id" [totalRecords]="totalRecords" [columns]="cols"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [resetPageOnSort]="false"
      [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25,50,totalRecords]" [resizableColumns]="true"
      columnResizeMode="expand">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="DateConsult" pResizableColumn>Date of Consult
            <p-sortIcon field="DateConsult"></p-sortIcon>
          </th>
          <th pSortableColumn="CaseNo" pResizableColumn>Case No.
            <p-sortIcon field="CaseNo"></p-sortIcon>
          </th>
          <th pSortableColumn="LyticStatus" pResizableColumn>Lytic Status
            <p-sortIcon field="LyticStatus"></p-sortIcon>
            </th>
          <th pSortableColumn="Facility" pResizableColumn>Facility
            <p-sortIcon field="Facility"></p-sortIcon>
          </th>
          <th pSortableColumn="PatientName" pResizableColumn>Patient Name
            <p-sortIcon field="PatientName"></p-sortIcon>
          </th>
          <th pSortableColumn="PatientDOB" pResizableColumn>Patient DOB
            <p-sortIcon field="PatientDOB"></p-sortIcon>
          </th>
          <th pSortableColumn="StartTime" pResizableColumn>Start Time
            <p-sortIcon field="StartTime"></p-sortIcon>
          </th>
          <th pSortableColumn="Phyician" pResizableColumn>Phyician
            <p-sortIcon field="Phyician"></p-sortIcon>
          </th>
          <th pSortableColumn="CaseType" pResizableColumn>Case Type
            <p-sortIcon field="CaseType"></p-sortIcon>
            </th>
          <th pSortableColumn="PatientIdentifier" pResizableColumn>Patient Identifier
            <p-sortIcon field="PatientIdentifier"></p-sortIcon>
          </th>
          <th pSortableColumn="WorkflowType" pResizableColumn>Workflow Type
            <p-sortIcon field="WorkflowType"></p-sortIcon>
          </th>
          <th pSortableColumn="LastKnownWell" pResizableColumn>Last Known Well
            <p-sortIcon field="LastKnownWell"></p-sortIcon>
          </th>
          <th pSortableColumn="EAlert" pResizableColumn>E-Alert
            <p-sortIcon field="EAlert"></p-sortIcon>
          </th>
          <th pSortableColumn="ArrivalTime" pResizableColumn>Arrival Time
            <p-sortIcon field="ArrivalTime"></p-sortIcon>
          </th>
          <th pSortableColumn="StampTime" pResizableColumn>Stamp Time
            <p-sortIcon field="StampTime"></p-sortIcon>
          </th>
          <th pSortableColumn="InitialTime" pResizableColumn>Initial Reponse Time
            <p-sortIcon field="InitialTime"></p-sortIcon>
          </th>
          <th pSortableColumn="AssessmentTime" pResizableColumn>Assessment Time
            <p-sortIcon field="AssessmentTime"></p-sortIcon>
          </th>
          <th pSortableColumn="StartTimetoNeedle" pResizableColumn>Start Time to Needle Time
            <p-sortIcon field="StartTimetoNeedle"></p-sortIcon>
          </th>
          <th pSortableColumn="ArrivaltoNeedle" pResizableColumn>Arrival to Needle Time
            <p-sortIcon field="ArrivaltoNeedle"></p-sortIcon>
          </th>
          <th pSortableColumn="Thrombolyticrelated" pResizableColumn>Thrombolytic-related Complication
            <p-sortIcon field="Thrombolyticrelated"></p-sortIcon>
          </th>
          <th pSortableColumn="ActivationTimeInterval" pResizableColumn>Activation Time Interval Metric
            <p-sortIcon field="ActivationTimeInterval"></p-sortIcon>
          </th>
          <th pSortableColumn="AssessmentTimeInterval" pResizableColumn>Assessment Time Interval Metric
            <p-sortIcon field="AssessmentTimeInterval"></p-sortIcon>
          </th>
          <th pSortableColumn="ThrombolyticDecisionInterval" pResizableColumn>Thrombolytic Decision Interval Metric
            <p-sortIcon field="ThrombolyticDecisionInterval"></p-sortIcon>
          </th>
          <th pSortableColumn="ThrombolyticAdministration" pResizableColumn>Thrombolytic Administration Interval Metric
            <p-sortIcon field="ThrombolyticAdministration"></p-sortIcon>
          </th>
          <th pSortableColumn="ThrombolyticMedicalDecision" pResizableColumn>Thrombolytic Medical Decision Time
            <p-sortIcon field="ThrombolyticMedicalDecision"></p-sortIcon>
          </th>
          <th pSortableColumn="NeedleTime" pResizableColumn>Needle Time
            <p-sortIcon field="NeedleTime"></p-sortIcon>
          </th>
          <th pSortableColumn="LVO" pResizableColumn>LVO
            <p-sortIcon field="LVO"></p-sortIcon>
          </th>
          <th pSortableColumn="ThrombolyticUsed" pResizableColumn>Thrombolytic Used
            <p-sortIcon field="ThrombolyticUsed"></p-sortIcon>
          </th>
          <th pSortableColumn="PreMorbidMRS" pResizableColumn>Pre-Morbid MRS
            <p-sortIcon field="PreMorbidMRS"></p-sortIcon>
          </th>
          <th pSortableColumn="DiscussedwithNIR" pResizableColumn>Discussed with NIR
            <p-sortIcon field="DiscussedwithNIR"></p-sortIcon>
          </th>
          <th pSortableColumn="DiscussedwithNIRTime" pResizableColumn>Discussed with NIR Time
            <p-sortIcon field="DiscussedwithNIRTime"></p-sortIcon>
          </th>
          <th pSortableColumn="ResponseDiscussedwithNIR" pResizableColumn>Initial Response Time to Discussed with NIR
            <p-sortIcon field="ResponseDiscussedwithNIR"></p-sortIcon>
          </th>
          <th pSortableColumn="RCATertiaryCauses" pResizableColumn>RCA-Tertiary Causes
            <p-sortIcon field="RCATertiaryCauses"></p-sortIcon>
          </th>
          <th pSortableColumn="AudioOnly" pResizableColumn>Audio Only
            <p-sortIcon field="AudioOnly"></p-sortIcon>
          </th>
          <th pSortableColumn="NIHSS" pResizableColumn>NIHSS
            <p-sortIcon field="NIHSS"></p-sortIcon>
          </th>
          <th pSortableColumn="NIHSSmayreliable" pResizableColumn>NIHSS may not be reliable due to
            <p-sortIcon field="NIHSSmayreliable"></p-sortIcon>
          </th>
          <th pSortableColumn="NIHSSreliableduetoreason" pResizableColumn>NIHSS may not be reliable due to- reason
            <p-sortIcon field="NIHSSreliableduetoreason"></p-sortIcon>
          </th>
          <th pSortableColumn="Symptoms" pResizableColumn style="width: 30% !important;">Symptoms
            <p-sortIcon field="Symptoms"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-cases>
        <tr>
          <td>{{cases.cas_billing_date_of_consult  | date:'MM/dd/yyyy'}}</td>
          <td>{{cases.cas_case_number}}</td>
          <td>{{cases.cas_metric_tpa_consult == true ? 'Yes' : 'No'}}</td>
          <td>{{cases.fac_name}}</td>
          <td>{{cases.cas_patient}}</td>
          <td>{{cases.cas_billing_dob | date:'MM/dd/yyyy'}}</td>
          <td>{{cases.cas_response_ts_notification | date:'MM/dd/yyyy HH:mm:ss'}}</td>
          <td>{{cases.PhysicianName}}</td>
          <td>{{cases.CaseType}}</td>
          <td>{{cases.PatientIdentifier}}</td>
          <td>{{cases.WorkflowType == 1 ? 'EMS' : cases.WorkflowType == 2 ? 'Inpatient' : cases.WorkflowType == 3 ? 'Triage/Walk-In' : cases.WorkflowType == 4 ? 'Symptom Onset During ED Stay' : ''}}</td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? (cases.cas_metric_lastwell_date_est  | date:'MM/dd/yyyy HH:mm:ss') : ''}}</td>
          <td>{{cases.cas_is_ealert == true ? 'Yes' : 'No'}}</td>
          <td>{{cases.cas_metric_door_time_est | date:'MM/dd/yyyy HH:mm:ss'}}</td> 
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? (cases.cas_metric_stamp_time_est  | date:'MM/dd/yyyy HH:mm:ss') : ''}}</td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? (cases.cas_metric_initial_response_time_est  | date:'MM/dd/yyyy HH:mm:ss') : ''}}</td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? (cases.cas_assessment_time_est | date:'MM/dd/yyyy HH:mm:ss') : ''}}</td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? cases.start_to_needle_time : ''}}</td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? cases.arrival_to_needle_time : ''}}</td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? (cases.cas_response_thrombolytic ? 'Yes' : 'No') : '' }}
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? cases.activation_to_starttime : ''}}</td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? cases.assessment_to_starttime : ''}}</td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? cases.thrombolytic_to_starttime : ''}}</td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? cases.needle_to_thrombolytic : ''}}</td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? (cases.cas_metric_alteplase_medical_decision | date:'MM/dd/yyyy HH:mm:ss') : ''}}</td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? (cases.cas_metric_needle_time_est | date:'MM/dd/yyyy HH:mm:ss') : ''}}</td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? (cases.ctai_lvo ? 'Yes' : 'No') : '' }}
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? cases.ThrombolyticUsed : ''}}</td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? cases.cas_metric_has_morbid_symptoms : ''}}</td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? (cases.ctai_discussed_with_nir ? 'Yes' : 'No') : '' }}
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? (cases.ctai_nir_discussion_time | date:'MM/dd/yyyy HH:mm:ss') : ''}}</td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? cases.ctai_initial_call_time_to_nir : ''}}</td>
          <td><ul *ngIf="cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult'" class="intial-li"><li *ngFor="let wfTitles of cases.CaseWorkflowTitles">{{wfTitles}}</li></ul></td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? (cases.cas_is_audio_consult ? 'Yes' : 'No') : '' }}
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' || cases.CaseType === 'Routine Consult- New' ? cases.cas_nihss_totalscore : ''}}</td>
          <td>{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' || cases.CaseType === 'Routine Consult- New' ? (cases.cas_nihss_cannot_completed ? 'Yes' : 'No') : '' }}
          <td>
            {{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' || cases.CaseType === 'Routine Consult- New' ?
              (cases.cas_NIHSS_comatose == 1 ? 'Patient is comatose' :
              cases.cas_NIHSS_comatose == 2 ? 'Patient was intubated and paralyzed' :
              cases.cas_NIHSS_comatose == 3 ? 'Other: ' + cases.cas_NIHSS_comatose_text : '')
              : ''
            }}
          </td>
          <td  style="min-width: 30rem !important; white-space: pre-wrap !important; word-wrap: break-word !important; overflow: auto !important; padding-top: 13px !important; padding-bottom: 13px !important;">{{cases.CaseType === 'Stroke Alert' || cases.CaseType === 'STAT Consult' ? cases.cas_metric_symptoms : ''}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <h5 *ngIf="totalRecords==0" class="text-center create-roles">
            <b> No records found</b></h5>
        </tr>
      </ng-template>
    </p-table>
    <div class="md:col-12">
      <span class="tableRefreshTime">
        <!-- Grid Last Refreshed at {{analyzeService._currentDate}} - {{analyzeService._currentTime}} -->
      </span>
    </div>
  </div>

  </div>